import { i18n } from "@/shared/i18n"
import { useInterface } from "@/shared/ui/useInterface"
import type { AxiosRequestConfig, AxiosResponse } from "axios"
import axios from "axios"

export const HTTP = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    headers: {
        "Content-Type": "application/json",
        "Accept-Language": i18n.global.locale.value
    }
})

export function useRestApi() {
    const { showNotification } = useInterface()

    function errorHandler(error: any) {

        if (error && error.response && error.response.data && error.response.data.message)
            showNotification(error.response.data.message, "danger")
        else if (error && error.message)
            showNotification(error.message, "danger")
        else
            showNotification(i18n.global.t("Message.Backend.Default"), "danger")
        console.error(error)
    }

    async function request(params: AxiosRequestConfig, responseWithData?: boolean, silent?: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            HTTP(params)
                .then(async(response: AxiosResponse) => {
                    if (
                        response &&
                        response.status === 200 &&
                        (responseWithData)
                            ? response.data
                            : true
                    )
                        resolve((responseWithData) ? response.data : true)
                    else {
                        if (!silent)
                            await showNotification(i18n.global.t("Message.Backend.NoData"), "danger")
                        reject()
                    }
                })
                .catch((error: any) => {
                    errorHandler(error)
                    reject(error)
                })
        })
    }

    return { request }
}
